import { render } from "./test_screen.vue?vue&type=template&id=e52d5692&scoped=true"
import script from "./test_screen.vue?vue&type=script&lang=js"
export * from "./test_screen.vue?vue&type=script&lang=js"

import "./test_screen.vue?vue&type=style&index=0&id=e52d5692&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e52d5692"]])

export default __exports__